export function isValidEmail (email){
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    return emailRegex.test(email);
}

export function isValidDisplayName (displayName){
    const alphanumericRegex = /^[\p{L}\p{N}\-_]+$/u; //supporting universal characters, hyphens and underscores  
    return alphanumericRegex.test(displayName);
}